import type { ExternalReference } from './external-reference.model';

export function transformExternalReference(
  request: ExternalReference,
): ExternalReference {
  return {
    ...request,
    content: request.content.replace(/\\n/g, '\n'),
  };
}
